import { $axios } from "./config";
import { getBase64Type, openFileInNewBrowser } from "../../util";
import { Buffer } from "buffer";

const url = "/workflows";

const getCaseAttachmentsByCaseId = async (caseId) => {
    return $axios.get(`${url}/getCaseAttachmentsByCaseId?caseId=${caseId}`);
};

const getAttachmentByDocumentId = async (docId) => {
    return $axios.get(`${url}/getAttachmentByDocumentId?documentId=${docId}`);
};
const getAllCaseDocuments = async (caseId) => {
    return $axios.get(`${url}/getCaseAttachmentsByCaseId?caseId=${caseId}`);
};

const getWorkflowHistoryAndTasksByWorkflowId = async (workflowId) => {
    return $axios.get(
        `${url}/getWorkflowHistoryAndTasksByWorkflowId?workflowId=${workflowId}`
    );
};

const assignBreachedCasesToROs = async (payload) => {
    return $axios.post(`${url}/AssignBreachedCasesToROs`, payload);
};

const returnCasesToFIsWithTask = async (formData) => {
    return $axios.post(`${url}/ReturnCasesToFIsWithTask`, formData);
};

const attachDocumentsToCase = async (formData) => {
    return $axios.post(`${url}/AttachDocumentsToCase`, formData);
};

const CPDInternalCaseEscalation = async (formData) => {
    return $axios.post(`${url}/CPDInternalCaseEscalation`, formData);
};

const CPDInternalCaseDeescalation = async (formData) => {
    return $axios.post(`${url}/CPDInternalCaseDeescalation`, formData);
};

const CPDCloseCase = async (payload) => {
    return $axios.post(`${url}/CPDCloseCase`, payload);
};

const ReCategoriseCases = async (payload) => {
    return $axios.post(`${url}/ReCategoriseCases`, payload);
};

const CPDEscalateCases = async (payload) => {
    return $axios.post(`${url}/escalateCases`, payload);
};

const CPDResolveCase = async (payload) => {
    return $axios.post(`${url}/CPDResolveCase`, payload);
};

const CPDReOpenCase = async (payload) => {
    return $axios.post(`${url}/CPDReOpenCase`, payload);
};

const getDocument = async (docId, fileName) => {
    const resp = await $axios
        .get(`/report/getAttachmentByDocumentId?documentId=${docId}`, {
            responseType: "arraybuffer",
        })
        .then((response) => {
            const base64URL = Buffer.from(response, "binary").toString(
                "base64"
            );
            const type =
                String(fileName).split(".")[
                    String(fileName).split(".").length - 1
                ];
            openFileInNewBrowser(
                getBase64Type(fileName) + base64URL,
                true,
                type == "pdf" ? type : "image"
            );
            // openFileInNewBrowser(response, false);
            // printJS({ printable: base64URL, type: 'pdf', base64: true })
        });
    // .catch((err) => { console.log(err); return ''});
};

const getActionableTasksByCaseId = async (caseId) => {
    return $axios.get(`${url}/getActionableTasksByCaseId?caseId=${caseId}`);
};

// const getCaseCommunicationByCaseId = async (caseId = '') => {
//     return $axios.get(`${url}/getCaseCommunicationByCaseId?caseId=${caseId}`);
// }

export {
    getCaseAttachmentsByCaseId,
    getAttachmentByDocumentId,
    getWorkflowHistoryAndTasksByWorkflowId,
    assignBreachedCasesToROs,
    CPDEscalateCases,
    returnCasesToFIsWithTask,
    attachDocumentsToCase,
    CPDInternalCaseEscalation,
    CPDInternalCaseDeescalation,
    CPDCloseCase,
    CPDResolveCase,
    getDocument,
    getAllCaseDocuments,
    getActionableTasksByCaseId,
    CPDReOpenCase,
    ReCategoriseCases,
};
